// Own only the input's text reservation; keep its themed outer box intact.
export const createInputSpace = (input) => {
  const originalPadding = input.style.getPropertyValue('padding-right');
  const originalPriority = input.style.getPropertyPriority('padding-right');
  const originalSpace = input.style.getPropertyValue(
    '--quick-search-control-space'
  );
  const originalSpacePriority = input.style.getPropertyPriority(
    '--quick-search-control-space'
  );
  let baseline = null;
  let lastGeometry = null;
  let lastInputSize = null;
  let appliedPadding = null;

  const restore = () => {
    if (originalPadding) {
      input.style.setProperty(
        'padding-right',
        originalPadding,
        originalPriority
      );
    } else {
      input.style.removeProperty('padding-right');
    }
    if (originalSpace) {
      input.style.setProperty(
        '--quick-search-control-space',
        originalSpace,
        originalSpacePriority
      );
    } else {
      input.style.removeProperty('--quick-search-control-space');
    }
    // The restored DOM no longer matches the cached reservation; allow reuse.
    baseline = null;
    lastGeometry = null;
    lastInputSize = null;
    appliedPadding = null;
  };

  const update = (controls) => {
    if (!controls) {
      return;
    }
    const inputBox = input.getBoundingClientRect();
    if (!inputBox.width || !inputBox.height) {
      // Hidden header instances must not replace their last useful measurement.
      baseline = null;
      return;
    }
    const controlsBox = controls.getBoundingClientRect();
    const geometry = [
      inputBox.left,
      inputBox.right,
      inputBox.top,
      inputBox.bottom,
      inputBox.width,
      inputBox.height,
      controlsBox.left,
      controlsBox.right,
      controlsBox.top,
      controlsBox.bottom,
      controlsBox.width,
      controlsBox.height,
    ];
    if (
      baseline &&
      lastGeometry &&
      geometry.every((value, index) => value === lastGeometry[index])
    ) {
      return;
    }

    if (
      !baseline ||
      !lastInputSize ||
      lastInputSize.width !== inputBox.width ||
      lastInputSize.height !== inputBox.height
    ) {
      // Refresh only after invalidation or an input resize; preserve theme overrides.
      restore();
      input.style.setProperty('--quick-search-control-space', '0px');
      const style = window.getComputedStyle(input);
      const padding = parseFloat(style.paddingRight) || 0;
      baseline = {
        padding,
        gap: Math.min(padding, parseFloat(style.paddingLeft) || 0),
        border: parseFloat(style.borderRightWidth) || 0,
      };
    }
    const { padding, gap, border } = baseline;
    const overlaps =
      controlsBox.width > 0 &&
      controlsBox.height > 0 &&
      controlsBox.left < inputBox.right &&
      controlsBox.right > inputBox.left &&
      controlsBox.top < inputBox.bottom &&
      controlsBox.bottom > inputBox.top;
    const space = overlaps
      ? Math.max(
          0,
          inputBox.right - border - Math.max(inputBox.left, controlsBox.left)
        ) + gap
      : 0;

    const nextPadding = `${Math.ceil(Math.max(padding, space))}px`;
    if (nextPadding !== appliedPadding) {
      input.style.setProperty('padding-right', nextPadding, originalPriority);
      appliedPadding = nextPadding;
    }
    lastGeometry = geometry;
    lastInputSize = { width: inputBox.width, height: inputBox.height };
  };

  return {
    update,
    restore,
    invalidate: () => {
      baseline = null;
    },
  };
};
